import React from 'react';
import Booking from '../components/Booking';

export default function BookingPage() {
  return <Booking />;
}
